export enum HelpLinkType {
    ARTICLE,
    EXTERNAL_ARTICLE,
    EXTERNAL,
    SCROLL,
    ATTACHMENT,
}
